import {
  RESETPASSWORD_REQUESTING,
  } from './constants'
  
export const resetPasswordRequest = function resetPasswordRequest (formData) {
  return {
    type: RESETPASSWORD_REQUESTING,
    formData,
  }
}
  
export default resetPasswordRequest


// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/actions.js